// src/pages/InventoryCounting/components/ImportPanel.jsx
import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { importInventoryFile } from '../../../../api/inventoryCountingApi';

const IMPORTS = [
  {
    type: 'stock',
    title: 'Zapas',
    description: 'Aktualny stan binów i produktów',
  },
  {
    type: 'dispatch',
    title: 'Wywozy',
    description: 'Aktualna lista produktów z planowanym wywozem',
  },
  {
    type: 'counting',
    title: 'Liczenia',
    description: 'Wyniki liczeń z EWM',
  },
];

export default function ImportPanel({ onImported }) {
  const [loadingType, setLoadingType] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = async (type, event) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file) return;

    setLoadingType(type);
    setMessage(null);
    setError(null);

    try {
      const result = await importInventoryFile(type, file);

      setMessage(
        `${file.name} zaimportowany poprawnie. Rekordy: ${
          result.rowsCount ??
          result.insertedRowsCount ??
          result.validRowsCount ??
          0
        }`,
      );

      if (onImported) onImported();
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Wystąpił błąd podczas importu.',
      );
    } finally {
      setLoadingType(null);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Import danych
      </Typography>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={2}>
        {IMPORTS.map((item) => (
          <Grid item xs={12} md={4} key={item.type}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardContent>
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight={700}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </Box>

                  <Button
                    component="label"
                    variant="contained"
                    startIcon={
                      loadingType === item.type ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        <CloudUploadIcon />
                      )
                    }
                    disabled={Boolean(loadingType)}
                  >
                    Wgraj plik
                    <input
                      hidden
                      type="file"
                      accept=".xlsx,.xls,.csv"
                      onChange={(event) => handleFileChange(item.type, event)}
                    />
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
